<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/rb")
          i.fas.fa-running
          span.ml-1 {{ $t("ui.running_ball") }}
      b-breadcrumb-item
        router-link(to="/rb/rbdata2")
          i.fas.fa-list
          span.ml-1 {{ $t("ui.rb_data_detail") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getRBDataList(true)"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div.row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="totalRow"
                :per-page="getPageSize"
                v-model="currentPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                b-input(:value="totalRow" readonly)
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 50%;" v-columns-resizable)
                  thead
                    tr
                      th
                        span {{ $t('ui.id') }}
                      th
                        span {{ $t("ui.rb_data") }}
                      th.text-right
                        span {{ $t("ui.created_on") }}
                      th.sticky-position.text-center(width="5%")
                          span
                  tbody.clusterize-content
                    tr(v-if="rbDataList.length == 0")
                      td(colspan="4").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in rbDataList")
                      td
                        span {{ item.data_id }}
                      td
                        span {{ decodeRBData(item.rb_data) }}
                      td.text-right
                        span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
                      td.actions
                        span
                          a.fa.fa-eye.text-primary(href="#" @click="onView(item)" :title="$t('ui.view')")
    rbdatadetail(ref="rbDataDetail" @failed="handleFailed" :item="detailInfo")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import beautify from "xml-beautifier";
import DateRangePicker from "vue2-daterange-picker";
import rbdatadetail from "@/components/rb/rbDataDetail.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    beautify,
    DateRangePicker,
    rbdatadetail
  },
  data: () => ({
    loading: false,
    rbDataList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    locale: {
      format: 'YYYY-MM-DD hh:mm:ss A',
      useCurrent: false,
      showClear: true,
      showClose: true,
    },
    currentPage: 1,
    totalRow: 0,
    detailInfo: null,
  }),
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    todayWithTime() {
      let time = '23:59:59';
      return this.$moment(this.today+ " " + time).format('YYYY-MM-DD HH:mm:ss');
    },
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    yesterdayWithTime() {
      let time = '00:00:00';
      return this.$moment(this.yesterday+ " " + time).format('YYYY-MM-DD HH:mm:ss');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    }
  },
  mounted: function() {
    this.startDate = this.yesterdayWithTime;
    this.endDate = this.todayWithTime;
  },
  methods: {
    decodeRBData(str) {
      if (str.includes("<match_list"))
        return "Match List";
      else if (str.includes("<event_list"))
        return "Event List";
      else if (str.includes("<keep_alive"))
        return "Keep Alive";
      else if (str.includes("<testing"))
        return "Testing";

      return "";
    },
    onView: function(a) {
      this.detailInfo = a;
      this.$refs.rbDataDetail.$refs.rbDataDetail.show();
    },
    getRBDataList: function(isSearch) {
      let url = config.getRBRawDataDetailUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.rbdata,
        date_from: this.startDate,
        date_to: this.endDate,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rbDataList = response.data.tbl_rb_raw_data;
                this.totalRow = this.rbDataList.length > 0 ? response.data.tbl_rb_raw_data[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getRBDataList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getRBDataList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>